import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormBuilder } from '@angular/forms';
import { ZoneService } from '../../../mesc.service';
import { Zone } from '../../../../../shared/model';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { MaintenanceService } from "../maintenance.service";

@Component({
  selector: 'Zone',
  template: '<cgp-grid [template]="template" [editDataItem]="editDataItem" [formDialog]="formDialog" [editForm]="editForm" (setModel)="setModelHandler()"></cgp-grid>',
})
export class ZonesComponent extends BaseGridTemplate {
  maintenanceService: MaintenanceService;

  constructor(
    private formBuilder: FormBuilder,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private readonly injector: Injector,
    /** Declare services here
     * EXAMPLE:
     * private userService: UserService,
     * private moduleService: ModuleService
     * 
     */
    private ZoneService: ZoneService,

  ) {
    super();
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();

    /** Call services here (optional)
     * EXAMPLE:
     * this.moduleService.query() or functionService.getById('{path}{id}')
     * 
     */

  }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  editForm = this.formBuilder.group({
    Id: [],
    CreatedBy: [],
    CreatedDate: [],
    Description: ["", Validators.required],
    DetailDescription: ["", Validators.required],
    IsActive: [false, Validators.required],

  })

  /** Define columns here
   * EXAMPLE:
   * columns: [
   * {
   *     field: Firstname,
   *     title: First Name
   * },
   * {
   *     field: Email,
   *     title: Email,
   *     template: {
   *         type: 'email',
   *     },
   * },
   * {
   *     field: "ModuleId",
   *     title: "Module",
   *     template: {
   *         type: 'filter',
   *         pipe: 'moduleName',
   *         dataSource: this.moduleService,
   *     }
   * },
   * {
   *     field: "GMIN",
   *     title: "",
   *     width: 55,
   *     template: {
   *         type: 'person'
   *     }
   * },
   * ]
   */
  columns = [
    {
      field: 'Description',
      title: 'Zone'
    },
    {
      field: 'DetailDescription',
      title: 'Description'
    },
    {
      field: 'IsActive',
      title: 'Status',
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },

  ]

  onSave = (dataItem, isNew) => {
    var self = this;
    self.ZoneService.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.ZoneService.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }


  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    save: this.onSave,
    service: this.ZoneService,
    fileName: 'zones.xlsx'
  }


  formDialog = {
    title: "Zone",
    formControls: [
      {
        type: "text",
        name: "Description",
        title: "Zone*",
      }, {
        type: "text",
        name: "DetailDescription",
        title: "Detail Description*",
      }, {
        type: "boolean",
        name: "IsActive",
        title: "Active",
      }],
  }


  setModelHandler(): void {
    this.editDataItem = new Zone();
    this.editDataItem.IsActive = false;
  }

}

